import React from 'react'
import PriceFormatter from '../../utils/price-formatter'
import createReactClass from 'create-react-class'
import {getPercentage} from "../../utils/percentage";


var UpsaleGroupTotal = createReactClass({

  getPriceTotal: function () {
    var price = this.props.itemList.reduce(function (sum, item) {
      return sum + item.getPrice(10);
    }, 0);
    return Math.round(price*100)/100;
  },
  getBasePriceTotal: function () {
    var price = 0.0;
    for (var i = 0; i < this.props.itemList.length; i++) {
      price += this.props.itemList[i].getBasePrice(10);
    }
    return Math.round(price*100)/100;
  },

  render: function() {
    const price = this.getBasePriceTotal();
    const discountedPrice = this.getPriceTotal();
    const discount = getPercentage(discountedPrice, price);
    const priceClass = "ope-upsale__group__total__sum price" + (discountedPrice && discount > 0 ? " discounted" : "");

    return (
      <div className="ope-upsale__group__total">
        {_('Amount')}
        <span className={priceClass}>{PriceFormatter(discountedPrice ? discountedPrice : price)}</span>
      </div>
    );
  }
});

export default UpsaleGroupTotal;
